// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  base_url: 'https://qaapi.paykoko.com/api/',
  freshChatToken: 'ad940638-0ac0-4e1e-bce2-dbcfe565ebf5',
  freshChatWidgetUuid: "b2af7069-0ba6-455d-a8ea-c1f8f618fc30",
  freshChatHost: "https://paykoko-team.freshchat.com"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
